<template>
  <div class="booling-box">
    <ul class="tabs-list">
      <li class="tab-link" v-for="(tab, index) in tabs" v-bind:key="index" :class="getLinkClass(index)" @click="tabClick(index)">{{tab.title}}</li>
    </ul>
    <div v-for="(component, name, index) in components" v-bind:key="index" :id="'tab-' + index" class="tab-content "
         :class="getTabClass(index)">
      <!--<keep-alive>-->
        <component :is="component" :key="index"/>
      <!--</keep-alive>-->
    </div>
  </div>
</template>

<script>

export default {
    name: 'tabs-component',

    props: {
      tabs: {
          type: Array
      },
      components: Object

    },
    data() {
        return {
            currentIndex: 0,
        }
    },
    computed: {

    },

    mounted() {
    },

    methods: {
        getLinkClass(index) {
            return this.currentIndex === index ? 'current' : '';
        },
        getTabClass(index) {
            return (this.currentIndex === index ? 'current' : '') + ' ' + (this.tabs[this.currentIndex].class)
        },
        tabClick(index) {
            this.currentIndex = index;
        }
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
